import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Language } from './shared/constants';
import { DeviceDetectorService } from 'ngx-device-detector';

import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { GoogleTagManagerService } from './shared/services/gtm.service';
import { RouterOutlet } from '@angular/router';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { ErrorInterceptorComponent } from './shared/components/error-interceptor/error-interceptor.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, LoaderComponent, ErrorInterceptorComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Parrot';
  public isMobile = false;
  public isDesktop = false;

  constructor(
    private translateService: TranslateService,
    private deviceService: DeviceDetectorService,
    private router: Router,
    private gtmService: GoogleTagManagerService
  ) {
    translateService.setDefaultLang(Language.ja_JP);
    this.translateService.use(Language.ja_JP);
    this.isMobile = this.deviceService.isMobile();
    this.isDesktop = this.deviceService.isDesktop() || this.deviceService.isTablet();
    this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe((e: NavigationEnd) => {
      const gtmTag = {
        event: 'page',
        pageName: e.urlAfterRedirects
      };
      console.log(e.urlAfterRedirects);
      this.gtmService.pushTag(gtmTag);
    });
  }
}
